// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZQXA","right":"styles_right__AKa4V"};